import { useQuery } from '@tanstack/react-query';
import { useOrganizationContext } from '@/providers/OrganizationProvider';
import { getLocationsAll } from '@/services/hacienda';
import { queryKeys } from '@/lib/queryKeys';
import { STALE_TIME_REFERENCE } from '@/lib/queryCacheConfig';
import {
  getCantonOptions,
  getDistrictOptions,
  getProvinceOptions,
} from '@/lib/crTerritorialDivision';

/**
 * CR locations from Hacienda `GET /locations/all`.
 * One cached fetch; cantons/districts filter client-side.
 */
export const useCrLocations = (province?: string, canton?: string) => {
  const { currentOrganization } = useOrganizationContext();
  const orgId = currentOrganization?.id ?? '';
  const hasApiKey = !!currentOrganization?.haciendaApiKey;
  const enabled = !!orgId && hasApiKey;

  const provinceCode = province?.trim() || '';
  const cantonCode = canton?.trim() || '';

  const { data: provincias, isPending } = useQuery({
    queryKey: queryKeys.locationsAll(orgId),
    queryFn: getLocationsAll,
    enabled,
    staleTime: STALE_TIME_REFERENCE.locations,
  });

  return {
    provinces: getProvinceOptions(provincias),
    cantons: getCantonOptions(provincias, provinceCode),
    districts: getDistrictOptions(provincias, provinceCode, cantonCode),
    // Disabled query stays pending in TQ v5; don't spin without org/API key.
    isLoading: enabled && isPending,
  };
};
